/**
 * POSIX/strptime pivot for a 2-digit year: `00`-`68` -> 2000s, `69`-`99` -> 1900s.
 * @param {number} year - A year in the range 0-99.
 * @returns {number} The 4-digit year.
 */
export function expandTwoDigitYear(year: number): number {
  return year + (year <= 68 ? 2000 : 1900);
}

/**
 * Expands typed year text of exactly 2 digits (`26` -> `2026`); anything else
 * is returned unchanged so partial or full entries are left for validation.
 * @param {string} text - The typed year text.
 * @returns {string} The 4-digit year, or `text` unchanged.
 */
export function expandYearText(text: string): string {
  return /^\d{2}$/.test(text) ? String(expandTwoDigitYear(Number(text))) : text;
}
